import { z } from "zod";
import { DEPOT } from "./delivery.js";
export const latLngSchema = z.object({
    lat: z.number().finite().min(-90).max(90),
    lng: z.number().finite().min(-180).max(180),
});
/** Straight-line radius from the office beyond which we do not deliver. */
export const SERVICE_RADIUS_KM = 25;
/**
 * Road km divided by straight-line km across the nine district points routed
 * on 13 Sep 2026 ranged 1.2 to 1.5. 1.35 is the middle; a fallback estimate
 * should be close, not flattering.
 */
export const DETOUR_FACTOR = 1.35;
const EARTH_RADIUS_KM = 6371.0088;
export function haversineKm(a, b) {
    const toRad = (deg) => (deg * Math.PI) / 180;
    const dLat = toRad(b.lat - a.lat);
    const dLng = toRad(b.lng - a.lng);
    const h = Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) ** 2;
    return 2 * EARTH_RADIUS_KM * Math.asin(Math.sqrt(h));
}
export function insideServiceArea(point) {
    return haversineKm(DEPOT, point) <= SERVICE_RADIUS_KM;
}
/** Used when the router is down. One decimal, like the router's figures. */
export function estimateKm(point) {
    return Math.round(haversineKm(DEPOT, point) * DETOUR_FACTOR * 10) / 10;
}
//# sourceMappingURL=geo.js.map